import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Grid,
  IconButton,
  Link,
  Paper,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useState } from 'react';
import ShippingStatusIcon from '../../../utils/common/ShippingStatusIcon';
import { TrackingNumberButton } from '../../../utils/common/TrackingNumberButton';

const OrderDetailsSummary = (props) => {
  const { line, orderDetails } = props;
  const [displayLineProducts, setDisplayLineProducts] = useState(false);
  const [infoDiscount, setInfoDiscount] = useState('');

  const handleDisplayLineProducts = () => {
    const symbol = getSymbolFromCurrency(orderDetails?.currency?.code);
    setInfoDiscount(
      `${orderDetails?.amounts?.discount?.code}: ${orderDetails?.amounts?.discount?.value} | ${line?.products?.discountTtc}${symbol}`
    );
    setDisplayLineProducts(!displayLineProducts);
  };

  return (
    <Box>
      <Accordion elevation={6} disableGutters expanded={displayLineProducts}>
        <AccordionSummary
          expandIcon={
            <ExpandMoreRoundedIcon onClick={handleDisplayLineProducts} />
          }
          sx={{
            userSelect: 'text',
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexGrow: 1,
            }}
          >
            <Box sx={{ display: 'flex', m: '0 4px', flexGrow: 1 }}>
              <Typography component={'span'} noWrap={true}>
                x{line?.quantity} {line?.reference}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexGrow: 1 }}>
              <Typography component={'span'} noWrap={false}>
                {line?.title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              {orderDetails?.type?.code === 'ORDER_SAV' &&
              !orderDetails?.isPayable ? (
                <Typography component={'span'} noWrap={true}>
                  <Chip
                    label="SAV Gratuit"
                    color="success"
                    variant="outlined"
                    size="small"
                  />
                </Typography>
              ) : (
                <Typography component={'span'} noWrap={true}>
                  {orderDetails?.contact?.store?.contactType?.codeBO === 'P'
                    ? line?.quantity * line?.products?.amountHt
                    : line?.quantity * line?.products?.amountTtc}
                  {getSymbolFromCurrency(orderDetails?.currency?.code)}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                m: '0 4px',
              }}
            >
              <Typography color="warning">
                {orderDetails?.amounts?.discount?.code
                  ? ` - ${orderDetails?.amounts?.discount?.value}`
                  : ''}
              </Typography>
            </Box>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {displayLineProducts === true && line?.products?.items?.length > 0 ? (
            <>
              {orderDetails?.amounts?.discount?.code && (
                <Chip
                  sx={{ m: '8px 4px', p: '4px' }}
                  label={infoDiscount}
                  color="warning"
                  variant="outlined"
                  size="small"
                  icon=<LocalOfferIcon />
                />
              )}
              {line?.products?.items?.map((item, index) => {
                return (
                  <Paper
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    key={index}
                  >
                    <Typography component={'span'}>
                      {item?.reference}
                    </Typography>
                    {item?.trackingNumber ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography component={'span'}>
                          {item?.trackingNumber}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={(_e) => {
                            navigator.clipboard.writeText(
                              `${item?.trackingNumber}`
                            );
                          }}
                        >
                          <ContentCopyRoundedIcon fontSize="inherit" />
                        </IconButton>
                        <TrackingNumberButton
                          variant="short"
                          size="small"
                          tracking={item?.trackingNumber}
                          shipper={orderDetails?.shipper}
                        />
                      </Box>
                    ) : null}
                    <ShippingStatusIcon orderStatus={item?.status} />
                  </Paper>
                );
              })}
            </>
          ) : null}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default OrderDetailsSummary;
